import {combineReducers} from "redux";
import ajouterAssignementGroupeCoursReducer from "./ajouterAssignementGroupeCours";
import supprimerAssignementGroupeCoursReducer from "./supprimerAssignementGroupeCours";


export default combineReducers({
    ajouterAssignementGroupeCours : ajouterAssignementGroupeCoursReducer,
    supprimerAssignementGroupeCours : supprimerAssignementGroupeCoursReducer
});